import { AuthenticationBy, EnvironmentNames } from '@app/shared/au-enums';

export const environment = {
	env: EnvironmentNames.prod,
	production: true,
	baseHref: '',
	baseUrl: 'https://app.autility.no',
	graphql: `https://app.autility.no/graphql/`,
	contextGraphql: 'https://graphical-context.autility.io/',
	cmmsHost: 'https://cmms.autility.no',
	cmmsGraphql: 'https://cmms.autility.no/graphql/',
	digitalTwinUrl: 'https://dt.autility.no',
	digitalTwinGraphql: 'https://dt.autility.no/graphql',
	federationGraphql: 'https://gql.app.autility.no/graphql',
	graphqlSubscriptions: `wss://stage.autility.no/graphql/`,
	dexterGraphql: 'https://dexter.autility.no/graphql/',
	aiChatUrl: 'https://autility--ai-chatbot-fastapi-app.modal.run/chat/vespa',
	aiChatStreamUrl: 'https://autility--ai-chatbot-fastapi-app.modal.run/chat/stream',
	authenticationBy: AuthenticationBy.keycloak,
	keycloak: {
		// Url of the Identity Provider
		issuer: 'https://auth.autility.no/auth/',
		// Realm
		// TODO also we need to rename realm for front end application.
		//  Now it has kinda stupid name
		realm: 'backend',
		// The SPA's id.
		// The SPA is registered with this id at the auth-server
		clientId: `angular:${EnvironmentNames.prod}`,
	},
};
